module.exports = __webpack_public_path__ + "img/安国中药.bcb60aa8.jpg";